var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "tasks" } },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            paths: [{ title: "Tasks" }],
            select: true,
            "show-subjects": false,
          },
        },
        [
          _vm.type === "kanban"
            ? _c("div", { staticClass: "custom-select" }, [
                _c(
                  "div",
                  {
                    staticClass: "selected-option",
                    on: { click: _vm.toggleDropdown },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.selectedOption.label.length > 15
                            ? _vm.selectedOption.label.substring(0, 15) + "..."
                            : _vm.selectedOption.label
                        ) +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.dropdownOpen
                  ? _c(
                      "div",
                      { staticClass: "options-workflow" },
                      _vm._l(_vm.getWorkflows(), function (option) {
                        return _c(
                          "div",
                          {
                            key: option.value,
                            staticClass: "option-workflow",
                            on: {
                              click: function ($event) {
                                return _vm.selectOption(option)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  option.label.length > 15
                                    ? option.label.substring(0, 15) + "..."
                                    : option.label
                                ) +
                                "\n                "
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "route-page-content breadcrumb-content" },
        [
          _c("SidebarChild", {
            attrs: {
              items: _vm.menuItems,
              "selected-item": _vm.type,
              focusActive: true,
            },
            on: {
              selected: function (i) {
                return (_vm.type = i.key)
              },
              clicked: _vm.fnClicked,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "page-content-wrapper" }, [
            _vm.type === ("kanban" || "list")
              ? _c("div", { staticClass: "head-bar" }, [
                  !!_vm.batchOperationItems().length
                    ? _c(
                        "div",
                        { staticClass: "batch-operation" },
                        [
                          _c(
                            "a-input-group",
                            { attrs: { compact: "" } },
                            [
                              _c("a-button", { attrs: { value: "test" } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                      gap: "5px",
                                    },
                                  },
                                  [
                                    _c("a-checkbox", {
                                      staticClass: "kanban-checkbox",
                                      attrs: {
                                        indeterminate: _vm.checkedAllTasks(),
                                        checked: _vm.checkedAllTask,
                                      },
                                      on: { change: _vm.changeCheckedTasks },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("a-button", { attrs: { value: "test" } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                      gap: "5px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.changeStageModal = true
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "material-icons",
                                        staticStyle: { "font-size": "20px" },
                                      },
                                      [_vm._v("table_chart")]
                                    ),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("task.changeStage")) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("a-button", { attrs: { value: "xd" } }, [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                      gap: "5px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.deleteMultipleTasksModal = true
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "material-icons",
                                        staticStyle: { "font-size": "20px" },
                                      },
                                      [_vm._v("delete")]
                                    ),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("chatbotv2.delete")) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "avatar-content",
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _vm._l(
                              _vm.filteredUsersAvatar,
                              function (user, index) {
                                return index < 8
                                  ? _c("div", { key: user._id }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "avatar-container",
                                          style: {
                                            border: _vm.isUserSelected(user._id)
                                              ? "2px solid #47499d"
                                              : "2px solid white",
                                            borderRadius: "50%",
                                            marginLeft:
                                              index !== 0 ? "-10px" : "0px",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggleUserSelection(
                                                user._id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("Avatar", {
                                            directives: [
                                              {
                                                name: "tippy",
                                                rawName: "v-tippy",
                                                value: {
                                                  followCursor: true,
                                                  placement: "bottom-end",
                                                },
                                                expression:
                                                  "{\n                                        followCursor: true,\n                                        placement: 'bottom-end',\n                                    }",
                                              },
                                            ],
                                            key: 1,
                                            staticStyle: { cursor: "pointer" },
                                            attrs: {
                                              size: 30,
                                              username: user.name,
                                              src: user.gravatar,
                                              content: user.name,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e()
                              }
                            ),
                            _vm._v(" "),
                            _vm.filteredUsersAvatar.length > 8
                              ? _c(
                                  "a-popover",
                                  {
                                    staticStyle: {
                                      display: "grid",
                                      gap: "5px",
                                    },
                                    attrs: {
                                      placement: "bottom",
                                      trigger: "click",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "content",
                                          fn: function () {
                                            return _vm._l(
                                              _vm.filteredUsersAvatar,
                                              function (user, index) {
                                                return index >= 8
                                                  ? _c(
                                                      "div",
                                                      {
                                                        key: user._id,
                                                        staticStyle: {
                                                          display: "flex",
                                                          "align-items":
                                                            "center",
                                                          "margin-bottom":
                                                            "5px",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "avatar-container",
                                                            style: {
                                                              border:
                                                                _vm.isUserSelected(
                                                                  user._id
                                                                )
                                                                  ? "2px solid #47499d"
                                                                  : "2px solid white",
                                                              borderRadius:
                                                                "50%",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.toggleUserSelection(
                                                                  user._id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("Avatar", {
                                                              directives: [
                                                                {
                                                                  name: "tippy",
                                                                  rawName:
                                                                    "v-tippy",
                                                                  value: {
                                                                    followCursor: true,
                                                                    placement:
                                                                      "bottom-end",
                                                                  },
                                                                  expression:
                                                                    "{\n                                                followCursor: true,\n                                                placement: 'bottom-end',\n                                            }",
                                                                },
                                                              ],
                                                              key: 1,
                                                              staticStyle: {
                                                                cursor:
                                                                  "pointer",
                                                              },
                                                              attrs: {
                                                                size: 30,
                                                                username:
                                                                  user.name,
                                                                src: user.gravatar,
                                                                content:
                                                                  user.name,
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              cursor: "pointer",
                                                              "margin-left":
                                                                "10px",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.toggleUserSelection(
                                                                  user._id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                        " +
                                                                _vm._s(
                                                                  user.name
                                                                    .length > 20
                                                                    ? user.name.substring(
                                                                        0,
                                                                        20
                                                                      ) + "..."
                                                                    : user.name
                                                                ) +
                                                                "\n                                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e()
                                              }
                                            )
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      2631026214
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "avatar-container",
                                        style: {
                                          border: "none",
                                          borderRadius: "50%",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          width: "30px",
                                          height: "30px",
                                          cursor: "pointer",
                                          backgroundColor: "#47499d",
                                          color: "white",
                                          fontSize: "14px",
                                          marginLeft: "-10px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                +" +
                                            _vm._s(
                                              _vm.filteredUsersAvatar.length - 8
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "avatar-container",
                                style: {
                                  border: _vm.isUserSelected("notAppointed")
                                    ? "2px solid #47499d"
                                    : "none",
                                  borderRadius: "50%",
                                  marginLeft: "-10px",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.toggleUserSelection(
                                      "notAppointed"
                                    )
                                  },
                                },
                              },
                              [
                                _c("Avatar", {
                                  directives: [
                                    {
                                      name: "tippy",
                                      rawName: "v-tippy",
                                      value: {
                                        followCursor: true,
                                        placement: "bottom-end",
                                      },
                                      expression:
                                        "{\n                                    followCursor: true,\n                                    placement: 'bottom-end',\n                                }",
                                    },
                                  ],
                                  key: 1,
                                  staticStyle: { cursor: "pointer" },
                                  attrs: {
                                    size: 30,
                                    username: "Atanmadı",
                                    src: "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp",
                                    content: "Atanmadı",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        gap: "10px",
                        cursor: "pointer",
                      },
                      on: { click: _vm.createTask },
                    },
                    [
                      _c("span", { staticClass: "md-icon" }, [
                        _vm._v("add_task"),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("Görev Oluştur")]),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "board" },
              [
                _vm.type === "workflowList"
                  ? _c("Workflow", {
                      on: { "selected-workflow": _vm.changeWorkflow },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.workflowId && _vm.type === "kanban"
                  ? _c("TaskDraggable", {
                      attrs: {
                        workflowId: _vm.workflowId,
                        assignees: _vm.assignees,
                      },
                      on: {
                        "update:workflowId": function ($event) {
                          _vm.workflowId = $event
                        },
                        "update:workflow-id": function ($event) {
                          _vm.workflowId = $event
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.type === "list"
                  ? _c("KanbanList", { attrs: { assignees: _vm.assignees } })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.deleteMultipleTasksModal,
            icon: "exclamation-circle",
            title: "Delete Task",
          },
          on: {
            cancel: function ($event) {
              _vm.deleteMultipleTasksModal = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: {
                        click: function ($event) {
                          _vm.deleteMultipleTasksModal = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.dismiss")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      attrs: { type: "danger" },
                      on: { click: _vm.deleteMultipleTasks },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("chatbotv2.delete")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_c("p", [_vm._v(_vm._s(_vm.$t("task.deleteTaskCont")))])]
      ),
      _vm._v(" "),
      _vm.changeStageModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Change Stage",
                description: "1 selected candidate(s)",
                "ok-text": "Save",
              },
              on: {
                cancel: function ($event) {
                  _vm.changeStageModal = false
                },
                ok: _vm.changeTaskPipeline,
              },
            },
            [
              _c(
                "div",
                { staticClass: "radio-group-container" },
                [
                  _c(
                    "a-radio-group",
                    {
                      model: {
                        value: _vm.selectedPipelineId,
                        callback: function ($$v) {
                          _vm.selectedPipelineId = $$v
                        },
                        expression: "selectedPipelineId",
                      },
                    },
                    _vm._l(_vm.defaultWorkflow.pipeline, function (pipeline) {
                      return _c(
                        "a-radio",
                        { key: pipeline._id, attrs: { value: pipeline._id } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(pipeline.name) +
                              "\n                "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }